module.exports = __webpack_public_path__ + "static/img/js_1.22da25a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/js_1.png
// module id = QldT
// module chunks = 1